import { render, staticRenderFns } from "./DetailsTagManager.vue?vue&type=template&id=14c845ea"
import script from "./DetailsTagManager.vue?vue&type=script&lang=js"
export * from "./DetailsTagManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports